export default [
  {
    label: 'Segment name',
    value: 'segment_name',
  },
  {
    label: 'Segment type',
    value: 'type'
  },
  {
    label: 'Size',
    value: 'segment_size',
  },
  {
    label: 'Last updated',
    value: 'last_updated'
  },
  {
    label: 'Last updated by',
    value: 'last_updated_user'
  },
  {
    label: '',
    value: 'segment_actions',
  }
]
